export const IS_RETURNING_USER_KEY = 'isReturningUser'
